import axios from 'axios';

export function newPaymentAttempt() {
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  return Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
}

export function paymentCancelled(provider, response) {
  if (provider === 'google') return response.code === 1;
  // Swing's iOS generic failure response is NOT a cancellation code.
  // Recognize only an explicit native StoreKit cancellation marker.
  try {
    const data = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
    return data && (data.code === 'SKErrorPaymentCancelled' || data.error?.code === 'SKErrorPaymentCancelled' ||
      (data.domain === 'SKErrorDomain' && Number(data.code) === 2));
  } catch (_) { return false; }
}

export function notifyPayment(body, config) {
  try {
    // Dispatch independently, never await. Even a synchronous transport failure is contained.
    Promise.resolve(axios.post('/api/dolligo/pay-inapp-log/payment-event', body, { ...config, timeout: 4000 })).catch(() => {});
  } catch (_) { /* Notifications must not change checkout UI or result. */ }
}
